import http from "@/settings/apiSettings"

class LookUpsService {
    save(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post("/RU_LookUps", data)
    }
}
export default new LookUpsService()